import * as loginPageConfigActionCreators from './loginPageConfigActionCreators';

export const getLoginPageConfig = () => (dispatch) => {
  dispatch(loginPageConfigActionCreators.getLoginPageConfig()).catch(
    (error) => {
      console.warn(error);
    }
  );
};
